import { MessageService } from './../../../_services/message.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-student-messaging-received-tab',
  templateUrl: './student-messaging-received-tab.component.html',
  styleUrls: ['./student-messaging-received-tab.component.css']
})
export class StudentMessagingReceivedTabComponent implements OnInit {
  messagesReceived=[]
  server_student_user_id=0
  dtOptions: any = {};
  constructor(private activeRoute:ActivatedRoute, private messageService:MessageService) {
    this.activeRoute.params.subscribe(
      id=>{
        this.server_student_user_id= +id
        this.messageService.getMessages(this.server_student_user_id).subscribe(
          val=>{
            this.messagesReceived=val['messagesReceived']

          }
        )
      }
    )
   }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: false,
      info    : false
     };
  }

}
